import { useForm } from "@inertiajs/react";
import { Box, Container, Heading, Input, Button, Text, VStack, HStack, Field, Separator } from "@chakra-ui/react";

interface Props {
  code?: string;
  player_code: string;
}

export default function Entry({ code, player_code }: Props) {
  const { data, setData, get, processing, errors } = useForm({
    code: code || "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    get("/my/1v1/games/new", {
      preserveState: true,
    });
  };

  return (
    <Container maxW="lg" py={6}>
      <Box bg="white" p={6} rounded="lg" shadow="sm">
        <Heading size="lg" textAlign="center" mb={6}>
          1v1 試合結果の入力
        </Heading>

        <Text fontWeight="bold" fontSize="sm" mb={1}>
          相手のコードを入力する
        </Text>
        <Text fontSize="xs" color="gray.500" mb={3}>
          対戦相手の画面に表示されている4桁のコードを入力してください
        </Text>

        <form onSubmit={handleSubmit}>
          <VStack gap={4}>
            <Field.Root invalid={!!errors.code}>
              <Input id="code" value={data.code} onChange={e => setData("code", e.target.value)} placeholder="相手の4桁コードを入力" maxLength={4} inputMode="numeric" pattern="[0-9]*" autoComplete="off" />
              <Field.ErrorText>{errors.code}</Field.ErrorText>
            </Field.Root>

            <Button type="submit" colorPalette="blue" size="lg" width="full" loading={processing}>
              次へ
            </Button>
          </VStack>
        </form>

        <HStack my={6}>
          <Separator flex="1" />
          <Text fontSize="xs" color="gray.400" flexShrink={0}>
            または
          </Text>
          <Separator flex="1" />
        </HStack>

        <Text fontWeight="bold" fontSize="sm" mb={3}>
          自分のコードを相手に伝える
        </Text>

        <Box bg="gray.50" p={6} rounded="md" textAlign="center">
          <Text fontSize="xs" color="gray.500" mb={2}>
            あなたの対戦コード（1日に1回変わります）
          </Text>
          <Text fontSize="4xl" fontWeight="bold" letterSpacing="0.2em">
            {player_code}
          </Text>
        </Box>

        <Text color="gray.400" fontSize="xs" textAlign="center" mt={6}>
          対戦結果の入力はどちらか一方が行えばOKです
        </Text>
      </Box>
    </Container>
  );
}
